import type { SVGProps } from 'react';
import { icons, type IconName } from '../icons/registry';
import styles from './Icon.module.css';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: IconSize;
  /** Accessible name. Without it the icon is decorative and hidden from assistive tech. */
  label?: string;
}

const pixels: Record<IconSize, number> = { xs: 14, sm: 16, md: 20, lg: 24, xl: 32 };

export function Icon({ name, size = 'md', label, className, ...rest }: IconProps) {
  const px = pixels[size];
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true as const };
  return (
    <svg
      viewBox="0 0 24 24"
      width={px}
      height={px}
      fill="none"
      stroke="currentColor"
      strokeWidth={size === 'xs' || size === 'sm' ? 2 : 1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      className={[styles.icon, className].filter(Boolean).join(' ')}
      {...a11y}
      {...rest}
    >
      {icons[name]}
    </svg>
  );
}
